// extracted by mini-css-extract-plugin
module.exports = {"page-header-accueil":"layout_page-header-accueil__3JXgq","page-body-accueil":"layout_page-body-accueil__7ZKv7","footer-accueil":"layout_footer-accueil__XxMke"};